import normalize from 'json-api-normalizer';

import { formatDateTime } from '../../shared/utilities/date';

import {
    Notification,
    NotificationFromAPI,
    NotificationJSONAPIResponse,
    SerializedNotification,
} from './types';

export const notificationSerializer = (notification: NotificationFromAPI): Notification =>
    ({
        id: notification.id,
        type: notification.attributes.eventName,
        occurredOn: formatDateTime(notification.attributes.occurredOn),
        subscriberId: notification.attributes.subscriberId,
        read: notification.attributes.read,
        dossierId: notification.attributes.dossierId,
        requesterName: notification.attributes.requesterName,
        enrichedData: notification.attributes.enrichedData,
    }) as Notification;

export const serializeNotificationFromAPI = (
    json: NotificationJSONAPIResponse,
): SerializedNotification => {
    const { notification: notifications } = normalize<{
        notification: { [key: string]: NotificationFromAPI };
    }>(json);
    return {
        notification: notifications
            ? Object.fromEntries(
                  Object.entries(notifications).map(([key, value]) => [
                      key,
                      notificationSerializer(value),
                  ]),
              )
            : {},
    };
};

export const serializeNotificationArrayFromAPI = (
    json: NotificationJSONAPIResponse,
): Notification[] => {
    const { notification: notifications } = normalize<{
        notification: { [key: string]: NotificationFromAPI };
    }>(json);
    return notifications ? Object.values(notifications).map(notificationSerializer) : [];
};
